module.exports = __webpack_public_path__ + "static/img/secFloorBg.c25fdd1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/secFloorBg.jpg
// module id = X8yl
// module chunks = 0